import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-565c2ed6")

_pushScopeId("data-v-565c2ed6")
const _hoisted_1 = { class: "editorImg" }
const _hoisted_2 = { class: "formCon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toast = _resolveComponent("toast")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: ["editormain", _ctx.comment_id ? 'editormainSecond' : '']
    }, [
      _createVNode("div", {
        id: 'editor' + _ctx.time
      }, null, 8, ["id"])
    ], 2),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editorImg, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "editorImgmain",
          key: item.url
        }, [
          _createVNode("img", {
            class: "img",
            src: item.url
          }, null, 8, ["src"]),
          _createVNode("img", {
            class: "close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.delImg && _ctx.delImg(...args))),
            "data-index": index,
            src: "https://static.soyoung.com/sy-pre/close-1608703800734.png"
          }, null, 8, ["data-index"])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["sub", _ctx.editorText.length >= 2 ? '' : 'dis'],
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " 提 交 ", 2)
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ]))
})